<template>
    <footer class="m-grid__item		m-footer ">
        <div class="m-container m-container--fluid m-container--full-height m-page__container">
            <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                    <span class="m-footer__copyright">
                        {{ year }} &copy;
                        <a href="javascript: void()" class="m-link">
                            ZIZI
                        </a>
                    </span>
                </div>
                <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                    <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
                        <li class="m-nav__item">
                            <router-link :to="{ name: 'about' }" class="m-nav__link">
                                <span class="m-nav__link-text">
                                    About
                                </span>
                            </router-link>
                        </li>
                        <li class="m-nav__item">
                            <router-link :to="{ name: 'terms' }" class="m-nav__link">
                                <span class="m-nav__link-text">
                                    T&C
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'footerbar',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/partials/Footer.vue